<template>
    <BreadCrumb PageTitle="Liste des compositions" />
    <ListeComposition/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeComposition from "@/components/Composition/ListeComposition.vue";

    export default defineComponent({
      name: "ListeCompositionPage",
      components: {
        BreadCrumb,
        ListeComposition,
      },
    });
  </script>